define('plugin/google-reviews/model/GoogleReviewsModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Google Reviews model
     *
     * @class GoogleReviewsModel
     */
    return BaseModel.extend({
        defaults: {
            totalReviews: '',
            averageRating: '',
            reviews: null,
            placeUrl: ''
        },
    });

});
